const Collapse = require('./src/components/Collapse.vue')
module.exports = Collapse
